import { render, staticRenderFns } from "./PostComment.vue?vue&type=template&id=bc8bb394&scoped=true&"
import script from "./PostComment.vue?vue&type=script&lang=ts&"
export * from "./PostComment.vue?vue&type=script&lang=ts&"
import style0 from "./PostComment.vue?vue&type=style&index=0&id=bc8bb394&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc8bb394",
  null
  
)

export default component.exports